import { useEffect, useState } from 'react';
import { getBookmarks, handleRequestError, Logger } from '@desp-aas/desp-ui-fwk';
import { IProfileAssets, UserProfileAssets } from './UserProfileAssets';

const logger = new Logger("component", "UserBookmarks");

export const UserBookmarks = () =>{
    const [bookmarks, setBookmarks] = useState<IProfileAssets>({});
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        setLoading(true)
        getBookmarks()
        .then((bookmarks)=>{
            let _bookmarks:IProfileAssets = {
                "dataset": [],
                "model": [],
                "application": [],
                "paper": [],
            };
            for(let b of bookmarks){
                try{
                    _bookmarks[b.type].push(b)
                }
                catch(e){
                    logger.error("error during bookmark parse", e);
                }
            }
            setBookmarks(_bookmarks);
        })
        .catch((e)=>{
            logger.error("get bookmarks error", e)
            handleRequestError(e, { defaultMessage: "An error has occured during bookmark retrieval" })
        })
        .finally(()=>{
            setLoading(false)
        })
    }, [])

    return (
        <>
            {/* <Breadcrumbs
                customBreadcrumbs={[
                    {
                        label: <>User profile</>,
                        onClick: ()=>{ navigate('/user') }
                        
                    },
                    {
                        label: <>Bookmarks</>,
                    }
                ]}
            /> */}
            <UserProfileAssets
                loading={loading}
                title="datasets" 
                type="dataset"
                assets={bookmarks}
            />
            <UserProfileAssets
                loading={loading}
                title="models"
                type="model"
                assets={bookmarks}
            />
            <UserProfileAssets
                loading={loading}
                title="applications"
                type="application"
                assets={bookmarks}
            />
            <UserProfileAssets
                loading={loading}
                title="documents"
                type="paper"
                assets={bookmarks}
            />
            <UserProfileAssets
                loading={loading}
                title="courses"
                type="course"
                assets={bookmarks}
            />
        </>

    )
}
